import { render, staticRenderFns } from "./TextAlignRichText.vue?vue&type=template&id=10d253f2&"
import script from "./TextAlignRichText.vue?vue&type=script&lang=js&"
export * from "./TextAlignRichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports